import { SVGProps } from "react";

export function ArrowUpFull(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      {...props}
    >
      <path
        d="M4.26172 1.06531L4.26172 7.45752"
        stroke="currentColor"
        stroke-width="0.946994"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.13306 3.19604L4.2638 1.06531L6.39453 3.19604"
        stroke="currentColor"
        stroke-width="0.946994"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

